<<template>
<div ref="basePanel">    
    <param-panel :config="config" :rs="rs" />
    <pager-panel :crowCount="config.rowCount" :cpageNo="config.pageNo" :cpageSize="config.pageSize"
    @CFHandler="CFHandler" :selIdx="selIdx" :rightList="config.rights">
     
        <li  :title='rs["mcardp"]'  :class='selIdx!=undefined? "nav-system":"nav-system disabled"'>
        <a href="javascript:" @click='FmakeCard'><span class='icon iconfontx icon-stuff-card'></span></a>
      </li>
      </pager-panel>
    <list-panel :config="config" :isAutoLoad='1' :rs="rs" @updateIdx="updateIdx" :selIdx="selIdx" />

    <weixin-right v-if="showBatch" :config="config" :rs="rs" :empId="empId" :empName="empName" 
    :ChongZhi="chongzhi" :BaoCan="baocan" :QingJia="qingjia"
    :PaiChe="paiche" :WeiXiu="weixiu" :ChuChai="chuchai" :BuKa="buka" @closeBP="closeBP"/>
</div>
</template>


<script>
import data from "./data";
import mixin from "@/fui/mixin";

export default {
  data() {
    return {
      config: data,
      showBatch: false
    };
  },
  

  methods: {
    UpdateWeixinRights() {
      const arr = this.getSelRow();
      //alert(arr.length);
      if (arr.length <= 0) this.alertRS("selFist");
      else {
        /* alert("1"+ this.config.url);
        alert("2"+this.$urlSq());
        alert("3"+arr); */
        this.$postData(
          this.config.url + "UpdateWeixinRights?" + this.$urlSq(),arr,
          data => {
            if (data && data.rs == 1) {
              this.$alert("更新成功！");
              this.$loadData(this.config);
            } else this.$alert("更新失败！");
          }
        );
      }
    },
    closeBP() {
      this.showBatch = false;
    },
    FmakeCard() {
       const arr = this.getSelRow();
       //const arr1=[1,2,3];
       //alert(arr1);
      // alert(arr[userNo]);
      // alert(arr[xm]);
       console.log(arr);
       console.log(arr.user_no);
       console.log(arr.xm);
      this.empId = arr.user_no;
      this.empName = arr.xm;
      this.chongzhi=arr.chongzhi;
      this.baocan=arr.baocan;
      this.qingjia=arr.qingjia;
      this.paiche=arr.paiche;
      this.weixiu=arr.weixiu;
      this.chuchai=arr.chuchai;
      this.buka=arr.buka;

      this.showBatch = true;
    },
    
  },
  components: {
    "weixin-right": () => import("./weixinRight")
  },
  mixins: [mixin.list],
};
</script>
